import React, { useState } from 'react';
import Event from './event';
import Breadcrumb from './breadcrumb';
import Faq from './faq';
import Howto from './howto';
import Jobposting from './jobposting';
import Article from './article';
import Person from './person';
import Website from './website';
import Video from './video';
import Organization from './organization';
import LocalBusiness from './localbusiness';
import Product from './product'; 
import Recipe from './recipe';


function Schema() {
  const data = { event: 'Article' }
  const [inputs, SetInputs] = useState(data);

  function handleChange(event) {
    let value = event.target.value;
    let name = event.target.name;
    SetInputs((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    })
  }
  return (
    <div className='container mt-5 mb-5 schema_markup_generator'>
      
      <div className='row'>
        <div className='col-md-12'>
          <h3 className='mb-3'>Which Schema markup would you like to create?</h3>
          <div className='form-group'>
            <select className='form-control' name="event" onChange={handleChange} value={inputs.event} >
              <option value="">
                Select Event
              </option>
              <option value="Article">
                Article
              </option>
              <option value="Breadcrumb">
                Breadcrumb
              </option>
              <option value="Event">
                Event
              </option>
              <option value="Faq Page">
                Faq Page
              </option>
              <option value="How-to">
                How-to
              </option>
              <option value="Job Posting">
                Job Posting
              </option>
              <option value="Organization">
                Organization
              </option>
              <option value="Local Business">
                Local Business
              </option>
              <option value="person">
                Person
              </option>
              <option value="product">
                Product
              </option>
              <option value="website">
                Website
              </option>
              <option value="video">
                Video
              </option>
              <option value="recipe">
                Recipe
              </option>
            </select>
          </div>
          {(inputs.event === 'Article') &&
            <Article />
          }
          {inputs.event === 'Breadcrumb' &&
            <Breadcrumb />
          }
          {inputs.event === 'Event' &&
            <Event />
          }
          {inputs.event === 'Faq Page' &&
            <Faq />
          }
          {inputs.event === 'How-to' &&
            <Howto />
          }
          {inputs.event === 'Job Posting' &&
            <Jobposting />
          }
          {inputs.event === 'Organization' &&
            <Organization />
          }
          {inputs.event === 'Local Business' &&
            <LocalBusiness />
          }
          {inputs.event === 'person' &&
            <Person />
          }
          {inputs.event === 'product' &&
            <Product />
          }
          {inputs.event === 'website' &&
            <Website />
          }
          {inputs.event === 'video' &&
            <Video />
          }
          {inputs.event === 'recipe' &&
            <Recipe />
          }
        </div>
      </div>
    </div>
  );
}

export default Schema